// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"styles_form_wrapper__38jBL"};